import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faTicket } from "@fortawesome/free-solid-svg-icons";
import Breadcrumb from "../../components/Ui_Element/Breadcrumb";
import DepartmentTaskAnalyticsPage from "./DepartmentTaskAnalyticsPage";
import CustomerTicketAnalyticsPage from "./CustomerTicketAnalyticsPage";

const BRAND_135 = "linear-gradient(135deg, #C04C2A 0%, #8B2A15 55%, #4A1B13 100%)";

const TABS = [
  { key: "department", label: "Department Task Analytics", icon: faBuilding },
  { key: "customer",   label: "Customer Ticket Analytics", icon: faTicket },
];

export default function AdminAnalyticsDashboardPage() {
  const [activeTab, setActiveTab] = useState("department");

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-red-50 p-3 md:p-5">
      <Breadcrumb pageName="Admin Analytics Dashboard" currentPage="Admin Analytics Dashboard" />

      {/* ── Tab Bar ── */}
      <div className="mt-4 flex flex-wrap gap-2 rounded-2xl border border-orange-100 bg-white p-2 shadow-sm" style={{ boxShadow: "0 8px 24px rgba(192,76,42,0.08)" }}>
        {TABS.map((tab) => {
          const active = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActiveTab(tab.key)}
              className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-xs font-bold transition sm:flex-none sm:text-sm"
              style={
                active
                  ? { background: BRAND_135, color: "#fff", boxShadow: "0 4px 14px rgba(192,76,42,0.30)" }
                  : { background: "transparent", color: "#64748b" }
              }
              onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = "rgba(192,76,42,0.06)"; }}
              onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = "transparent"; }}
            >
              <FontAwesomeIcon icon={tab.icon} />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* ── Active Tab Content ── */}
      {activeTab === "department" ? (
        <DepartmentTaskAnalyticsPage embedded />
      ) : (
        <CustomerTicketAnalyticsPage embedded />
      )}
    </div>
  );
}
